import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ListSkeletonVariant = 'classes' | 'users';

@Component({
  selector: 'app-list-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-skeleton.component.html',
  styleUrls: ['./list-skeleton.component.scss']
})
export class ListSkeletonComponent {
  @Input() count = 4;
  @Input() variant: ListSkeletonVariant = 'classes';

  get items(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
